<template>
  <div class="app-container">
    <div>
      <div>
        <div style="padding: 200px; text-align:center" v-if="isWinLoading" class="text-dark-gray">请稍候，正在加载数据...</div>
        <!-- h -->
        <!-- 禁用条件：新增或者编辑页面并且点击过一次保存了 -->
        <el-button type="primary" style="margin: 10px" @click="save" v-if="Status === 0" :disabled="editType ? true : false" v-show="!isWinLoading">保存</el-button>
      </div>
      <el-form :model="data" :inline="true" :line-form="true" label-width="100px" status-icon v-if="!isWinLoading">
        <!-- h -->
        <el-row class="border">
          <el-form-item label="订单号">
            <span class="sapn w193px el-form-item__content">{{ data.OrderNo }}</span>
          </el-form-item>
          <el-form-item label="布产单号">
            <span class="sapn w193px el-form-item__content">{{ data.OrderProductNo }}</span>
          </el-form-item>
          <el-form-item label="单据日期">
            <span class="sapn w193px el-form-item__content">{{ $commonJs.toDateString(data.ClothDocDate) }}</span>
          </el-form-item>
          <el-form-item label="客户名称">
            <span class="sapn w193px el-form-item__content">{{ data.FullName }}</span>
          </el-form-item>
          <el-form-item label="存货编码">
            <span class="sapn w193px el-form-item__content">{{ data.ProductNo }}</span>
          </el-form-item>
          <el-form-item label="存货名称">
            <span class="sapn w193px el-form-item__content">{{ data.ProductName }}</span>
          </el-form-item>
          <el-form-item label="属性">
            <span class="sapn w193px el-form-item__content">{{ data.PropertyName }}</span>
          </el-form-item>
          <el-form-item label="颜色">
            <span class="sapn w193px el-form-item__content">{{ data.ColorName }}</span>
          </el-form-item>
          <el-form-item label="销售单位">
            <span class="sapn w193px el-form-item__content">{{ data.SaUnitName }}</span>
          </el-form-item>
          <el-form-item label="规格型号">
            <span class="sapn w193px el-form-item__content">{{ data.ProductSpec }}</span>
          </el-form-item>
          <el-form-item label="经手人">
            <span class="sapn w193px el-form-item__content">{{ data.ClothMakeEmpName }}</span>
          </el-form-item>
          <el-form-item label="订单数量">
            <span class="sapn w193px el-form-item__content">{{ $commonJs.toThousands(data.SaQuantity) }}</span>
          </el-form-item>
          <el-form-item label="生产单位">
            <span class="sapn w193px el-form-item__content">{{ data.BaseUnitName }}</span>
          </el-form-item>
          <el-form-item label="库存可用量">
            <span class="sapn w193px el-form-item__content">{{ data.StockQuantity }}</span>
          </el-form-item>
          <el-form-item label="生产数量">
            <el-input class="w193px" v-if="Status === 0" type="number" clearable v-model="data.Quantity" @blur="changeQuantityEnd" @change="changeQuantity" placeholder="请输入生产数量"></el-input>
            <span class="sapn w193px el-form-item__content" v-else>{{ $commonJs.toThousands(data.Quantity) }}</span>
          </el-form-item>
          <el-form-item label="生产部门">
            <dp-select :disabled="Status === 1" style="width: 193px" v-model="data.DpId" />
          </el-form-item>
          <el-form-item label="BOM版本号">
            <!-- <el-input
              v-if="Status === 0"
              clearable
              v-model="data.ProductBomNo"
              placeholder="请输入BOM版本号"
              @keyup.enter.native="search"
            ></el-input> -->
            <el-select v-if="Status === 0" clearable v-model="data.ProductBomNo" placeholder="请选择BOM版本号" filterable @change="search">
              <el-option v-for="item in teProductList" :key="item.TeProductId" :value="item.Bomno" :label="item.Bomno"></el-option>
            </el-select>
            <span class="sapn w193px el-form-item__content" v-else>{{ data.ProductBomNo }}</span>
          </el-form-item>
          <el-form-item label="完工时间">
            <el-date-picker style="width: 193px" v-if="Status === 0" v-model="data.FinishDate" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期" :clearable="false" />
            <span class="sapn w193px el-form-item__content" v-else>{{ $commonJs.toDateString(data.FinishDate) }}</span>
          </el-form-item>
          <el-form-item label="布产日期">
            <el-date-picker style="width: 193px" v-if="Status === 0" v-model="data.ClothDate" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期" :clearable="false" />
            <span class="sapn w193px el-form-item__content" v-else>{{ $commonJs.toDateString(data.ClothDate) }}</span>
          </el-form-item>
          <el-col :span="12">
            <el-form-item label="批号" v-if="data.IsBatchNumber">
              <div style="width: 334px">
                <el-input class="w250px" v-if="Status === 0" v-model="data.BatchNumber" @change="changeBatchNumber" clearable></el-input>
                <span class="sapn w250px el-form-item__content" v-else>{{ data.BatchNumber }}</span>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注">
              <div style="width: 334px">
                <el-input class="w250px" v-if="Status === 0" type="text" clearable v-model="data.ClothRemark" placeholder="请输入备注"></el-input>
                <span class="sapn w250px el-form-item__content" v-else>{{ data.ClothRemark }}</span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-tabs tab-position="top" v-show="!isWinLoading">
        <!-- h -->
        <el-tab-pane :label="'注塑('+(editType?editInjection.length:InjectionData.length)+')'" v-if="show1">
          <injection-molding
            ref="injection"
            :readonly="readonly"
            :QuickProcess="QuickProcess"
            :InjectionMouldBoms="InjectionData"
            :sc-quantity="Quantity"
            :edit-rubbers="editRubbers"
            :tradeUnitListProp="tradeUnitList"
            :edit-injection="editInjection"
            :OrderProductNo="data.OrderProductNo"
            :Status="Status"
            :editType="editType"
            @setListEnd="setListEnd"
            :equipmentListProp="equipmentList"
            :warehouseProp="warehouseList"
            :isEdit="isEdit"
            :initProductProp="initProductData"
            :teProcessProp="teProcessList"
          ></injection-molding>
        </el-tab-pane>
        <!-- <el-tab-pane label="特殊工艺工单" v-if="show2">
          <special-process
            ref="special"
            :special-boms="SpecialData"
            :sc-quantity="Quantity"
            :QuickProcess="QuickProcess"
            :editSpecial="editSpecial"
            :tradeUnitListProp="tradeUnitList"
            :propertyListProp="propertyList"
            :OrderProductNo="data.OrderProductNo"
            :editType="editType"
            :Status="Status"
            :equipmentListProp="equipmentList"
            :warehouseProp="warehouseList"
          ></special-process>
        </el-tab-pane> -->
        <!-- <el-tab-pane label="配件工单" v-if="show3">
          <parts-order
            ref="parts"
            :parts-boms="PartsData"
            :sc-quantity="Quantity"
            :QuickProcess="QuickProcess"
            :editParts="editParts"
            :propertyListProp="propertyList"
            :tradeUnitListProp="tradeUnitList"
            :OrderProductNo="data.OrderProductNo"
            :editType="editType"
            :Status="Status"
            :equipmentListProp="equipmentList"
            :warehouseProp="warehouseList"
            @changeList="changeListParts"
            @ChangeListParts="changeListPartsList"
          ></parts-order>
        </el-tab-pane>
        <el-tab-pane label="装配工单" v-if="show4">
          <assembly-order
            ref="assembly"
            :assembling-boms="AssemblingData"
            :sc-quantity="Quantity"
            :QuickProcess="QuickProcess"
            :edit-assembling="editAssembling"
            :OrderProductNo="data.OrderProductNo"
            :tradeUnitListProp="tradeUnitList"
            :propertyListProp="propertyList"
            :editType="editType"
            :Status="Status"
            @ChangeListArray="ChangeListArray"
            @changeList="changeListAssemly"
            :equipmentListProp="equipmentList"
            :warehouseProp="warehouseList"
          ></assembly-order>

        </el-tab-pane>
        <el-tab-pane label="组合工单" v-if="show5">
          <combination-order
            ref="combination"
            :combination-data="CombinationData"
            :sc-quantity="Quantity"
            :QuickProcess="QuickProcess"
            :edit-combination="editCombination"
            :OrderProductNo="data.OrderProductNo"
            :tradeUnitListProp="tradeUnitList"
            :editType="editType"
            :Status="Status"
            @changeList="setList"
            :equipmentListProp="equipmentList"
            :warehouseProp="warehouseList"
          ></combination-order>
        </el-tab-pane> -->
        <el-tab-pane v-for="(item, index) in MachiningStageData" :key="index" :label="item.Name+'('+item.Data.length+')'">
          <assembly-for-order
            :ref="'refName' + index"
            :assembling-boms="item.sonData"
            :sc-quantity="Quantity"
            :QuickProcess="QuickProcess"
            :edit-assembling="editAssembling_for"
            :OrderProductNo="data.OrderProductNo"
            :tradeUnitListProp="tradeUnitList"
            :propertyListProp="propertyList"
            :editType="editType"
            :Status="Status"
            @changeList="changeListAssemly"
            :equipmentListProp="equipmentList"
            :warehouse-prop="warehouseList"
            :isEdit="isEdit"
            :machiningStageId="item.MachiningStageId"
            :stage-name="item.Name"
            :mstage="item"
            :initProductProp="initProductData2"          
            :teProcessProp="teProcessList"
            :initTrademarkProp="initMarkData"
          ></assembly-for-order>
        </el-tab-pane>
        <el-tab-pane :label="'原料清单('+MaterialsData.length+')'">
          <materials-order ref="materials" :materials-data="MaterialsData" :sc-quantity="Quantity" :editType="editType" :Status="Status" :OrderProductNo="data.OrderProductNo"></materials-order>
        </el-tab-pane>
      </el-tabs>
    </div> 
  </div>
</template>

<script>
import injectionMolding from '@/components/production/clothmanagement/cloth/workorder/injectionMolding'
import specialProcess from '@/components/production/clothmanagement/cloth/workorder/specialProcess'
import partsOrder from '@/components/production/clothmanagement/cloth/workorder/partsOrder'
import assemblyOrder from '@/components/production/clothmanagement/cloth/workorder/assemblyOrder'
import assemblyForOrder from '@/components/production/clothmanagement/cloth/workorder/assemblyForOrder'
import combinationOrder from '@/components/production/clothmanagement/cloth/workorder/combinationOrder'
import materialsOrder from '@/components/production/clothmanagement/cloth/workorder/materialsOrder'
import dpSelect from '@/components/production/clothmanagement/cloth/workorder/dpSelect'
import cost from '@/api/ba/cost'
import { Stage } from 'driver.js'

export default {
  name: 'editcloth',
  components: {
    injectionMolding,
    specialProcess,
    partsOrder,
    assemblyOrder,
    combinationOrder,
    dpSelect,
    materialsOrder,
    assemblyForOrder
  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      api: require('@/api/production/clothProduction').default,
      workDocApi: require('@/api/production/workDoc').default,
      productApi: require('@/api/ba/product').default,
      mouldApi: require('@/api/ba/mould').default,
      tradeUnitApi: require('@/api/ba/tradeUnit').default,
      propertyApi: require('@/api/ba/property').default,
      classApi: require('@/api/ba/class').default,
      dpApi: require('@/api/ent/dp').default,
      teMouldBomApi: require('@/api/production/teMouldBom').default,
      equipmentApi: require('@/api/ba/equipment').default,
      machiningStageApi: require('@/api/ba/machiningStage').default,
      productList: [],
      mouldList: [],
      teProductApi: require('@/api/production/teProduct').default,
      teProductList: [],
      optionApi: require('@/api/sy/option').default,
      warehouseApi: require('@/api/ba/warehouse').default,
      productionPlanApi: require('@/api/production/productionPlan').default,
      teProcessApi: require('@/api/production/teProcess').default,
      trademarkApi: require('@/api/ba/trademark').default,
      warehouseList: [],
      data: {
        OrderNo: '',
        OrderProductNo: '',
        OrderDate: '',
        FullName: '',
        ColorId: 0,
        SaUnitId: 0,
        DpName: '',
        EmpName: '',
        ProductId: 0,
        OrderId: 0,
        OrderProductId: 0,
        ProductNo: '',
        ProductName: '',
        ProductSpec: '',
        ProductionDpId: 0,

        ColorName: '',
        SaUnitName: '',
        BaseUnitName: '',
        ProductBomNo: '',
        SaQuantity: 0,
        StockQuantity: '',
        Quantity: 1,
        DpId: null,
        DpName: '',

        ClothMakeEmpName: '',
        ClothMakeEmpId: null,
        ClothRemark: '',
        FinishDate: '',
        ClothDate: '',
        BatchNumber: null,
        ClothDocDate: '',
        ClothTradeUnitId: null,
        ClothTradeUnitName: '',
        IsBatchNumber: false,
        PropertyName:''
      },
      Quantity: 1,

      CombinationData: {},
      MaterialsData: [],
      AssemblingData: {},
      PartsData: {},
      SpecialData: {},
      InjectionData: [],
      MachiningStageData: [], //加工阶段
      InjectionRubbers: [],

      TeProductId: 0,

      editRubbers: [],
      initQuantity: 1,

      editInjection: [],
      editCombination: [],
      editAssembling: [],
      editParts: [],
      editSpecial: [],
      editAssembling_for: [],

      clickAssembling: false,
      editType: 0, // 0 未保存，1保存过了
      Status: 0,
      tradeUnitList: [], // 供应商列表
      propertyList: [], // 特殊加工列表
      shebeiList: [], // 设备列表
      dpList: [],
      isChange: false,
      isDataQuantityChange: false,
      equipmentList: [],
      QuickProcess: false, // 是否启动快捷方式
      newGlue: [],
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
      isEdit: null,
      IsProductionAvailable: false,
      initProductData: {},
      initProductData2: {},
      teProcessList:[],
      initMarkData:{},
      isWinLoading: true // <!-- h -->
    }
  },
  created() {
      this.teProcessApi.list({}).then(res => {
        if (res.Code === 0) {
          this.teProcessList = res.Data
        }
      })
    this.equipmentApi.list({ Statuses: [1, 2] }).then(res => {
      if (res.Code === 0) {
        this.equipmentList = res.Data
      }
    })

    this.mouldApi.list({ Statuses: [1, 2] }).then(res => {
      if (res.Code === 0) {
        this.mouldList = res.Data
      }
    })

    this.warehouseApi.list({ WarehouseType: 1 }).then(res => {
      if (res.Code === 0) {
        this.warehouseList = res.Data
      }
    })

    this.tradeUnitApi.list({ TradeUnitTypes: [3], Status: 1 }).then(res => {
      if (res.Code === 0) {
        this.tradeUnitList = res.Data
      }
    })

    this.propertyApi.list({ Status: 1 }).then(res => {
      if (res.Code === 0) {
        this.propertyList = res.Data
        console.log(this.propertyList, 'propertyList')
      }
    })

    this.classApi.list({ Status: 1, ClassType: 9 }).then(res => {
      let shebeiList = this.$commonJs.toTreeData(res.Data, 'ClassId')
      localStorage.setItem('shebeiList', JSON.stringify(shebeiList))
    })

    this.dpApi.list({ Status: 1 }).then(res => {
      let dpList = this.$commonJs.toTreeData(res.Data, 'DpId')
      localStorage.setItem('dpList', JSON.stringify(dpList))
    })

    this.optionApi.getProductSetting().then(res => {
      if (res.Code === 0) {
        this.QuickProcess = res.Data.QuickProcess
      }
    })

    this.machiningStageApi.list({ Status: 1 }).then(res => {
      if (res.Code === 0) {
        res.Data.forEach(item => {
          if (item.Name === '注塑') {
            if (item.UseProcess) {
              this.show1 = true
              this.show2 = true
            } else {
              this.show1 = true
              this.show2 = false
            }
          }
          if (item.Name === '配件') {
            if (!item.Status) this.show3 = true
          }
          if (item.Name === '装配') {
            if (!item.Status) this.show4 = true
          }
          if (item.Name === '组合') {
            if (!item.Status) this.show5 = true
          }
        })
      }
    })
    this.productApi
      .list({
        ProcessStage: 0,
        Status: 1,
        pageSize: 7,
        pageIndex: 1
      })
      .then(res => {
        if (res.Code == 0) {
          this.initProductData = res
        }
      })
      
    this.productApi
      .list({
        ProcessStages: [2, 1, 0],
        Status: 1,
        pageSize: 7,
        pageIndex: 1
      })
      .then(res => {
        if (res.Code == 0) {
          this.initProductData2 = res
        }
      })
      this.trademarkApi.list({ Status: 1,
        pageSize: 7,
        pageIndex: 1})
        .then(res=>{
          if(res.Code==0){
            this.initMarkData=res;
          }
        })
  },
  mounted() {
    if (this.$route.params.resData !== '') {
      this.editType = 1
      this.Status = this.$route.params.data.Status
      this.editInit(this.$route.params.resData, this.$route.params.data)
    } else {
      this.editType = 0
      this.Status = this.$route.params.data.Status
      this.init(this.$route.params.data)
    }
    this.isEdit = this.$route.params.isEdit
    console.log(this.isEdit,this.editType, 'mounted')
  },
  methods: {
    /** 获取循环加工阶段 */
    getProcess(ProductId, BomNo, OrderProductNo, Quantity) {
      console.log('bomInfo') // <!-- h -->
      this.api.bomInfo({ ProductId, BomNo, Qty: Quantity, BatchNumber: this.data.BatchNumber }).then(res => {
        if (res.Code === 0) {
          console.log('bomInfo  ...') // <!-- h -->

          this.data.ProductBomNo = res.Data.Bomno
          let { MachiningStage } = res.Data
          this.MachiningStageData = []
          this.MachiningStageData = this.get_data2(MachiningStage, OrderProductNo)
        } else {
          this.$message.warning('找不到相关记录')
        }
      })
    },
    changeQuantityEnd(data) {
      if (!this.isChange) {
      }
    },
    setList(data, dataProductId = 0) {
      this.isChange = true
      this.$refs.assembly.setList(data, dataProductId)
    },
    setListEnd(data, type = 0) {
      this.isChange = true
      console.log(' setListEnd', JSON.parse(JSON.stringify(data)))

      this.setMouldData(data, type)
    },
    changeListPartsList(data) {
      console.log('data', data)
      this.isChange = true
      // 按加工阶段分类
      let special = data.filter(item => {
        return item.UseProcess && item.ProcessStage === 1 && item.PropertyId !== 1 && item.PropertyId !== 0
      })
      let injection = data.filter(item => {
        return item.ProcessStage === 1 && item.PropertyId === 1
      })

      if (special.length !== 0) {
        console.log('触发执行特殊')
        special.forEach(item => {
          this.$refs.special.setList(item)
        })
      }
      if (injection.length !== 0) {
        injection.forEach(item => {
          this.$refs.injection.setList(item)
        })
      }
    },
    ChangeListArray(data) {
      this.isChange = true
      // 按加工阶段分类
      let parts = data.filter(item => {
        return item.ProcessStage === 2
      })
      let special = data.filter(item => {
        return item.UseProcess && item.ProcessStage === 1 && item.PropertyId !== 1 && item.PropertyId !== 0
      })
      let injection = data.filter(item => {
        return item.ProcessStage === 1 && item.PropertyId === 1
      })

      if (parts.length !== 0) {
        parts.forEach(item => {
          this.$refs.parts.setList(item)
        })
      }
      if (special.length !== 0) {
        special.forEach(item => {
          this.$refs.special.setList(item)
        })
      }
      if (injection.length !== 0) {
        injection.forEach(item => {
          this.$refs.injection.setList(item)
        })
      }
    },
    changeListParts(data, dataProductId = 0, lastProcessStage = -1, lastPropertyId = 0) {
      this.isChange = true
      console.log('changeListParts data ChildBomNo', data.ChildBomNo)
      console.log('changeListParts data json', JSON.parse(JSON.stringify(data)))

      if (data.UseProcess && data.ProcessStage === 1 && data.PropertyId !== 1 && data.PropertyId !== 0) {
        this.$refs.special.setList(data)
      } else if (data.ProcessStage === 1 && data.PropertyId === 1) {
        console.log('执行调用')
        this.$refs.injection.setList(data)
      } else if (data.ProcessStage === 0) {
        console.log('changeListAssemly 无', dataProductId, lastProcessStage, lastPropertyId)
        if (lastProcessStage === 1 && lastPropertyId !== 1 && lastPropertyId !== 0) {
          console.log('changeListAssemly 特殊')
          this.$refs.special.setList(data, dataProductId)
        } else if (lastProcessStage === 1 && lastPropertyId === 1) {
          console.log('changeListAssemly 胶件')
          this.$refs.injection.setList(data, dataProductId)
        }
      }
    },
    changeListAssemly(data, dataProductId = 0, lastProcessStage = -1, lastPropertyId = 0) {
      this.isChange = true
      // console.log("changeListAssemly data ChildBomNo", data.ChildBomNo);
      // console.log(
      //   "changeListAssemly data json",
      //   JSON.parse(JSON.stringify(data))
      // );

      if (data.ProcessStage === 2) {
        this.$refs.parts.setList(data)
      } else if (data.UseProcess && data.ProcessStage === 1 && data.PropertyId !== 1 && data.PropertyId !== 0) {
        this.$refs.special.setList(data)
      } else if (data.ProcessStage === 1 && data.PropertyId === 1) {
        console.log('执行调用')
        this.$refs.injection.setList(data)
      } else if (data.ProcessStage === 0) {
        if (lastProcessStage === 2) {
          console.log('changeListAssemly 配件')
          this.$refs.parts.setList(data, dataProductId)
        } else if (lastProcessStage === 1 && lastPropertyId !== 1 && lastPropertyId !== 0) {
          console.log('changeListAssemly 特殊')
          this.$refs.special.setList(data, dataProductId)
        } else if (lastProcessStage === 1 && lastPropertyId === 1) {
          console.log('changeListAssemly 胶件')
          this.$refs.injection.setList(data, dataProductId)
        }
      }
    },
    callBomInfo(ProductId, BomNo, OrderProductNo, Quantity) {
      // <!-- h -->
      // var loading = this.$loading({
      //   lock: true,
      //   text: '正在查询...',
      //   spinner: 'el-icon-loading',
      //   customClass: 'my_loading',
      //   background: 'rgba(0, 0, 0, 0.3)'
      // })
      this.api
        .bomInfo({ ProductId, BomNo, Qty: Quantity, BatchNumber: this.data.BatchNumber })
        .then(res => {
          //loading.close()  // <!-- h -->
          if (res.Code === 0) {
            this.data.ProductBomNo = res.Data.Bomno
            let { Combination, Assembling, Injection, Parts, Special, Materials, TeProductId, MachiningStage } = res.Data

            this.TeProductId = TeProductId
            this.CombinationData = []
            this.MaterialsData = Materials || []
            this.AssemblingData = []
            this.SpecialData = []
            this.PartsData = []
            this.InjectionData = []
            console.log('InjectionData', this.InjectionData) // <!-- h -->
            this.MachiningStageData = []

            this.CombinationData = this.get_data(Combination, OrderProductNo)
            this.AssemblingData = this.get_data(Assembling, OrderProductNo)
            this.SpecialData = this.get_data(Special, OrderProductNo)
            this.PartsData = this.get_data(Parts, OrderProductNo)

            this.MachiningStageData = this.get_data2(MachiningStage, OrderProductNo)
            this.MachiningStageData.forEach(x => {
              x.DpId = this.data.DpId
            })
            console.log(this.MachiningStageData, 'this.MachiningStageData ')
            Injection.forEach(item => {
              item.OrderProductNo = OrderProductNo
              item.DpId = this.data.DpId
            })

            this.InjectionData = Injection
            console.log('InjectionData', this.InjectionData) // <!-- h -->
            if (this.InjectionData) {
              let Injection1 = this.sumRubbers(Injection)
              console.log(Injection1, 'this.sumRubbers ')
              this.setMouldData(Injection1)
            }
          } else {
            this.$message.warning('找不到相关记录, 请先添加bom再操作')
          }
        })
        .catch(err => {
          //loading.close() // <!-- h -->
          console.error(err)
        })
    },
    sumRubbers(data) {
      let arr = []
      let copyData = JSON.parse(JSON.stringify(data))
      copyData.forEach(item => {
        let length = arr.length
        // console.log('length', length)
        let bool = true
        for (let i = 0; i < length; ++i) {
          // console.log('item', item)
          // console.log('arr', arr)
          if (item.ProductId === arr[i].ProductId && item.MouldId === arr[i].MouldId && item.MouldBomNo === arr[i].MouldBomNo) {
            arr[i].Quantity = arr[i].Quantity + item.Quantity
            console.log(`arr[${i}].Quantity`, arr[i].Quantity)
            arr[i].qua = arr[i].qua + item.qua
            console.log(`arr[${i}].qua`, arr[i].qua)
            bool = false
            break
          }
        }
        if (bool) {
          arr.push(item)
          // console.log('arr', arr)
        }
      })

      console.log('sumRubbers arr', arr)

      return arr
    },
    dataFilter(data, stage) {
      return data.filter(item => {
        return item.Stage === stage
      })
    },
    get_data(dataList, OrderProductNo) {
      let arr = []
      let _DetailModels = []
      let _ProcessModels = []
      console.log(dataList, 'get_data')
      dataList?.forEach(item => {
        console.log(item, 'dataList')
        let { DetailModels, ProcessModels, ...rest } = item
        rest.OrderProductNo = OrderProductNo
        arr.push(rest)
        console.log(DetailModels, 'DetailModels')
        DetailModels.forEach(x => {
          x.DpId = this.data.DpId
          x.BatchNumber = this.data.BatchNumber
        })
        _DetailModels.push({
          Pname: rest.ProductName,
          pid: rest.ProductId,
          fqua: rest.Quantity,
          DetailModels,
          BatchNumber: this.data.BatchNumber
        })
        _ProcessModels.push({
          Pname: rest.ProductName,
          Pno: rest.ProductNo,
          pid: rest.ProductId,
          ProgrammeId: ProcessModels[0]?.ProgrammeId ?? 0,
          ProgrammeName: ProcessModels[0]?.ProgrammeName ?? '',
          Processes: ProcessModels
        })
      })

      return {
        Bom: arr,
        DetailModels: _DetailModels, //产品子件
        ProcessModels: _ProcessModels
      }
    },
    /** 加工阶段 循环 */
    get_data2(dataList, OrderProductNo) {
      let res = []
      let arr = []

      console.log('get_data2 b') // <!-- h -->

      res = dataList?.map(i => {
        arr = this.get_data(i.Data, OrderProductNo)
        return {
          ...i,
          sonData: arr
        }
      })

      console.log('get_data2 e') // <!-- h -->

      this.isWinLoading = false // <!-- h -->

      return res
    },
    setMouldData(Injection, type = 0) {
      this.glueData = JSON.parse(JSON.stringify(Injection))
      this.glueData.forEach(x => {
        x.DpId = this.data.DpId
        x.BatchNumber = this.data.BatchNumber
        console.log(x, 'setMouldData')
      })
      console.log('this.glueData', this.glueData)
      if (this.glueData.length !== 0) {
        // 根据模号分类
        // let o = {};
        // this.glueData.forEach((item) => {
        //   console.log("item.MouldId", item.MouldBomNo, item.Pname);
        //   if (o["_" + item.MouldBomNo] == null) {
        //     o["_" + item.MouldBomNo] = [];
        //   }
        //   if (o["_" + item.MouldBomNo]) {
        //     let v = {
        //       ProductId: item.ProductId,
        //       ProductName: item.ProductName,
        //       ColorId: item.ColorId,
        //       ColorName: item.ColorName,
        //       MouldId: item.MouldId,
        //       MouldBomNo: item.MouldBomNo,
        //       Quantity: Number(item.qua) || Number(item.Quantity),
        //     };
        //     o["_" + item.MouldBomNo].push(v);
        //     console.log("o json", JSON.parse(JSON.stringify(o)));
        //   }
        // });
        // console.log("o json", JSON.parse(JSON.stringify(o)));

        // 根据id 获取产出的胶件及其数量
        // let mouldId_arr = Object.keys(o);
        // console.log('mouldId_arr==========', mouldId_arr)

        let mouldId_arr = this.glueData.map(item => item.MouldBomNo)
        console.log(mouldId_arr, 'mouldId_arr')
        mouldId_arr = Array.from(new Set(mouldId_arr))

        let Pres = []
        for (let i = 0; i < mouldId_arr.length; ++i) {
          // console.log('mouldId_arr[i].substr(1)', mouldId_arr[i].substr(1), typeof mouldId_arr[i].substr(1))

          // ssssssssssssssss
          let p = this.teMouldBomApi.bomList({ BomNo: mouldId_arr[i], IsEqBomNo: true })
          Pres.push(p)
        }
        if (Pres.length === 0) {
          return
        }
        console.log(Pres, 'pres')
        let glue = []

        Promise.all(Pres).then(res => {
          let length = res.length
          let quas = []
          for (let i = 0; i < length; ++i) {
            if (res[i].Code === 0) {
              console.log(`res[${i}].Data==============`, res[i].Data)
              let { BomRubbers, DetailDtos, ProcessModels, Bomno, BatchNumber, Wages, UnqualifiedInWarehouseId, ...rest } = res[i].Data[0]
              let dataArr = BomRubbers
              dataArr.forEach(item => {
                if (item.ColorId == null) {
                  item.ColorId = 0
                  item.MouldBomNo = Bomno
                }
                item.BatchNumber = this.data.BatchNumber
                item.Wages = Wages
                item.UnqualifiedInWarehouseId = UnqualifiedInWarehouseId
              })
              console.log('dataArr==========', dataArr)
              let mouldId = res[i].Data[0]?.MouldId
              let MouldBomNo = Bomno

              console.log('MouldBomNo====', MouldBomNo)
              console.log('=============rest====', res[i].Data[0])

              // 在注塑bom胶件中找到需要用到的胶件
              let glueDatas = this.glueData.filter(item => {
                return item.MouldBomNo === MouldBomNo
              })
              console.log(glueDatas, 'glueDatas')

              // 如果大于1，证明有多个胶件来自同个bom
              if (glueDatas.length > 1) {
                let maxQua = 0
                for (let i = 0; i < glueDatas.length; ++i) {
                  let mouldQuas = dataArr.filter(item => {
                    return item.ProductId === glueDatas[i].ProductId
                  })[0]

                  if (mouldQuas) {
                    let quantity = Number(glueDatas[i].qua) || Number(glueDatas[i].Quantity)
                    let qua = Math.ceil(quantity / mouldQuas.Quantity)

                    if (qua > maxQua) {
                      maxQua = qua
                    }
                  }
                }

                quas.push({
                  ...rest,
                  DetailDtos: DetailDtos,
                  ProcessModels: ProcessModels,
                  MouldId: mouldId,
                  MouldBomNo: MouldBomNo,
                  Quantity: maxQua,
                  mouldQua: rest.Quantity,
                  BatchNumber: this.data.BatchNumber,
                  Wages: Wages,
                  UnqualifiedInWarehouseId: UnqualifiedInWarehouseId
                })
                console.log(quas, 'quas')
              }

              if (glueDatas.length === 1) {
                let glueData = glueDatas[0]

                let mouldQuas = dataArr.filter(item => {
                  return item.ProductId === glueData.ProductId
                })[0]

                if (mouldQuas) {
                  let quantity = Number(glueData.qua) || Number(glueData.Quantity)
                  let qua = Math.ceil(quantity / mouldQuas.Quantity)

                  quas.push({
                    ...rest,
                    DetailDtos: DetailDtos,
                    ProcessModels: ProcessModels,
                    MouldId: mouldId,
                    MouldBomNo: MouldBomNo,
                    Quantity: qua,
                    mouldQua: rest.Quantity,
                    BatchNumber: this.data.BatchNumber,
                    Wages: Wages,
                    UnqualifiedInWarehouseId: UnqualifiedInWarehouseId
                  })
                  console.log(quas, 'quas')
                }
              }

              // let glueDatasMapId = glueDatas.map(item => item.ProductId)

              // let otherGlue = dataArr.filter((item) => {
              //   return glueDatasMapId.indexOf(item.ProductId) === -1
              // })

              // glue.push(...otherGlue)
            }
          }

          // this.newGlue = glue;

          let arr3 = JSON.parse(JSON.stringify(quas))

          // quas.forEach(item => {
          //   let index = ids.indexOf(item.MouldId);

          //   let qua = quas.filter((v) => {
          //     return item.MouldId === v.MouldId && item.ColorId === v.ColorId;
          //   })[0];

          //   if (qua) {
          //     let o = {
          //       MouldBomNo: qua.MouldBomNo,
          //       Quantity: qua.Quantity,
          //       ColorId: qua.ColorId,
          //       ColorName: qua.ColorName,
          //       ...this.mouldList[index],
          //     };
          //     arr3.push(o);
          //   }
          // })
          arr3.forEach(x => {
            x.DpId = this.data.DpId
            x.BatchNumber = this.data.BatchNumber
            x.DetailDtos.forEach(w => {
              w.BatchNumber = this.data.BatchNumber
            })
          })
          console.log('arr3 =========== json', arr3)
          if (this.$refs.injection) this.$refs.injection.setMould(arr3, type)
        })
      } else {
        this.$refs.injection.clearData()
      }
    },

    editInit(resData, data) {
      console.log('🚀 ~ 进入editInit ~ ', resData)
      let {
        OrderNo,
        OrderProductNo,
        OrderDate,
        FullName,
        ColorId,
        UnitId2,
        DpName,
        EmpName,
        ProductId,
        OrderId,
        OrderProductId,
        ProductNo,
        ProductName,
        ProductSpec,
        ProductionDpId,
        ColorName,
        UnitName2,
        ProductBomNo,
        SaQuantity,
        scDpName = '',
        StockQuantity = 0,
        ClothMakeEmpName,
        ClothMakeEmpId,
        ClothRemark,
        FinishDate,
        SaUnitName,
        BaseUnitName,
        ClothDate,
        BatchNumber,
        ClothDocDate,
        ClothTradeUnitId,
        ClothTradeUnitName,
        IsBatchNumber
      } = data
      if (ProductBomNo == null) {
        ProductBomNo = ''
      }
      this.initQuantity = resData.Quantity
      this.teProductApi.list({ Disabled: 0, ProductId }).then(res => {
        if (res.Code === 0) {
          this.teProductList = res.Data
        }
      })

      this.Quantity = resData.Quantity / this.initQuantity
      this.TeProductId = resData.TeProductId

      this.data = {
        OrderNo,
        OrderProductNo,
        OrderDate: resData.OrderDate,
        FullName: resData.FullName,
        ColorId,
        UnitId2,
        DpName,
        EmpName,
        ProductId,
        OrderId,
        OrderProductId,
        ProductNo,
        ProductName,
        ProductSpec,
        ProductionDpId,
        ColorName,
        UnitName2,
        ProductBomNo,
        Quantity: resData.Quantity,
        SaQuantity,
        DpId: resData.DpId,
        scDpName,
        StockQuantity,
        ClothMakeEmpName,
        ClothMakeEmpId,
        ClothRemark,
        FinishDate,
        SaUnitName,
        BaseUnitName,
        ClothTradeUnitId: resData.TradeUnitId,
        ClothDate: ClothDate ? ClothDate : resData.OrderDate,
        BatchNumber,
        ClothDocDate: resData.OrderDate,
        ClothTradeUnitName: resData.ClothTradeUnitName ? resData.ClothTradeUnitName : resData.FullName,
        IsBatchNumber
      }

      this.getProcess(ProductId, ProductBomNo, OrderProductNo, this.data.Quantity)

      // 设置缓存
      localStorage.setItem('printClothRemark', ClothRemark)
      localStorage.setItem('printOrderDate', this.$commonJs.toDateString(OrderDate))
      localStorage.setItem('printOrderProductNo', OrderProductNo)
      localStorage.setItem('printDpName', DpName)
      localStorage.setItem('printProductName', ProductName)
      localStorage.setItem('printProductSpec', ProductSpec)
      localStorage.setItem('printFinishDate', this.$commonJs.toDateString(FinishDate))
      localStorage.setItem('printBatchNumber', BatchNumber)

      let { RubberModels, WorkDocModels, MaterialModels } = resData
      this.MaterialsData = MaterialModels || []
      this.editRubbers = RubberModels

      let combination = this.dataFilter(WorkDocModels, 4)
      let assembly = this.dataFilter(WorkDocModels, 3)
      let parts = this.dataFilter(WorkDocModels, 2)
      let special = this.dataFilter(WorkDocModels, 1)
      let injection = this.dataFilter(WorkDocModels, 0)
      console.log(RubberModels, 'RubberModels', injection)

      this.editAssembling_for = WorkDocModels

      this.editInjection = injection
      this.editCombination = combination
      this.editAssembling = assembly
      this.editParts = parts
      this.editSpecial = special

      if (this.editInjection.length == 0) this.show1 = false
      if (this.editSpecial.length == 0) this.show2 = false
      if (this.editParts.length == 0) this.show3 = false
      if (this.editAssembling.length == 0) this.show4 = false
      this.$nextTick(() => {
        if (this.editCombination.length == 0) this.show5 = false
      })

      // console.log("combination", combination);
      // console.log("assembly", assembly);
      // console.log("injection", injection);
      // console.log("parts", parts);
      // console.log("special", special);
      // console.log("RubberModels", RubberModels);
      // this.setMouldData(RubberModels)

      // this.$nextTick(() => {
      //   this.tabClick({ index: "3" });
      //   this.chuli_data();
      // });

      console.log('....editInit....')
    },
    async init(data) {
      console.log('🚀 ~ 进入init ~ ')
      let {
        OrderNo,
        OrderProductNo,
        OrderDate,
        FullName,
        ColorId,
        SaUnitId,
        DpName,
        EmpName,
        ProductId,
        OrderId,
        OrderProductId,
        ProductNo,
        ProductName,
        ProductSpec,
        ProductionDpId,
        ColorName,
        SaUnitName,
        BaseUnitName,
        ProductBomNo,
        SaQuantity,
        DpId,
        scDpName = '',
        StockQuantity = 0,
        Quantity,
        Remark,
        DeliveryDate,
        ClothDate,
        BatchNumber,
        ClothDocDate,
        FinishDate,
        ClothTradeUnitId,
        ClothQuantity,
        IsBatchNumber,
        PropertyId,
        PropertyName
      } = data
      if (ProductBomNo == null) {
        ProductBomNo = ''
      }
      this.teProductApi.list({ Disabled: 0, ProductId }).then(res => {
        if (res.Code === 0) {
          this.teProductList = res.Data
        }
      })

      const user = this.$store.state.user
      let ClothMakeEmpName = user.name
      let ClothMakeEmpId = user.empId
      let ClothRemark = Remark
      FinishDate = FinishDate ? FinishDate : DeliveryDate
      ClothDocDate = ClothDocDate ? ClothDocDate : OrderDate

      // 生产数量是否考虑可用量(IsProductionAvailable)true
      // 库存可用量(StockQuantity)   生产数量(ClothQuantity)

      const res = await this.productionPlanApi.info()
      this.IsProductionAvailable = res.Data.IsProductionAvailable
      if (this.IsProductionAvailable) {
        Quantity = ClothQuantity - StockQuantity > 0 ? ClothQuantity - StockQuantity : ClothQuantity
      } else {
        Quantity = ClothQuantity
      }

      this.initQuantity = Quantity
      this.Quantity = Quantity / this.initQuantity

      this.data = {
        OrderNo,
        OrderProductNo,
        OrderDate,
        FullName,
        ColorId,
        SaUnitId,
        DpName,
        EmpName,
        ProductId,
        OrderId,
        OrderProductId,
        ProductNo,
        ProductName,
        ProductSpec,
        ProductionDpId,
        ColorName,
        SaUnitName,
        BaseUnitName,
        ProductBomNo,
        Quantity,
        SaQuantity,
        DpId,
        scDpName,
        StockQuantity,
        ClothMakeEmpName,
        ClothMakeEmpId,
        ClothRemark,
        FinishDate,
        ClothDate: ClothDate ? ClothDate : this.$commonJs.getToday(),
        BatchNumber,
        ClothDocDate,
        ClothTradeUnitId,
        ClothQuantity,
        IsBatchNumber,
        PropertyId,
        PropertyName
      }
      if (!this.data.IsBatchNumber) {
        this.data.BatchNumber = ''
      }
      console.log('init data', this.data)

      this.callBomInfo(ProductId, ProductBomNo, OrderProductNo, this.data.Quantity, this.data.BatchNumber)
    },

    search() {
      this.init(this.data)
      // let { ProductId, ProductBomNo, OrderProductNo } = this.data;
      // this.callBomInfo(
      //   ProductId,
      //   ProductBomNo,
      //   OrderProductNo,
      //   this.data.Quantity
      // );
    },
    changeQuantity(val) {
      this.data.Quantity = parseFloat(val)
      //this.Quantity = this.data.Quantity / this.initQuantity;
      let { ProductId, ProductBomNo, OrderProductNo } = this.data
      if (this.buttonType == 'savecloth') return
      this.callBomInfo(ProductId, ProductBomNo, OrderProductNo, this.data.Quantity)
    },
    changeBatchNumber() {
      let { ProductId, ProductBomNo, OrderProductNo } = this.data
      if (this.buttonType == 'savecloth') return
      this.callBomInfo(ProductId, ProductBomNo, OrderProductNo, this.data.Quantity)
    },
    setSaveData(data) {
      data.forEach(item => {
        item.OrderId = this.data.OrderId
        item.OrderProductId = this.data.OrderProductId
        // item.ProductModels.forEach((v) => {
        //   v.TeProductId = this.TeProductId;
        // });
      })
    },
    // setRutterQua(val) {
    //   this.tabClick({ index: "3" });
    //   this.chuli_data();
    // },
    save() {
      let WorkDocModels = []

      let assemblyData = []
      let combinationData = []
      let MaterialsData = []
      let partsData = []
      let specialData = []
      let injectionData = []

      /** 组合工单获取 */
      if (this.$refs.combination) {
        combinationData = this.$refs.combination.sendData()
        this.setSaveData(combinationData)
        WorkDocModels.push(...combinationData)
      }

      /** 外件购工单获取 */
      if (this.$refs.materials) {
        MaterialsData = this.$refs.materials.MaterialsBom
      }

      /** 装配工单获取 */
      if (this.$refs.assembly) {
        assemblyData = this.$refs.assembly.sendData()
        this.setSaveData(assemblyData)
        WorkDocModels.push(...assemblyData)
      }

      /** 配件工单获取 */
      if (this.$refs.parts) {
        partsData = this.$refs.parts.sendData()
        this.setSaveData(partsData)
        WorkDocModels.push(...partsData)
      }

      /** 特殊工艺工单获取 */
      if (this.$refs.special) {
        specialData = this.$refs.special.sendData()
        this.setSaveData(specialData)
        WorkDocModels.push(...specialData)
      }

      let RubberModelsArr = []
      let MachiningStageDates = []
      /** 注塑工单获取 */
      if (this.$refs.injection) {
        let { arr, RubberModels } = this.$refs.injection.sendData()
        RubberModelsArr = RubberModels
        injectionData = arr
        if (RubberModels) {
          RubberModelsArr.forEach(item => {
            item.OrderId = this.data.OrderId
            item.OrderProductId = this.data.OrderProductId
          })
        }
        this.setSaveData(injectionData)
        WorkDocModels.push(...injectionData)
        if (injectionData[0].batchShowEndTime) MachiningStageDates.push({ Stage: 0, OrderId: this.data.OrderId, OrderProductId: this.data.OrderProductId, EndTime: injectionData[0].batchShowEndTime })
      }

      for (let index = 0; index < this.MachiningStageData.length; index++) {
        let refName = `refName${index}` // 构建引用名称
        let ref = this.$refs[refName] // 获取引用
        let arr = ref[0].sendData() // 调用sendData()方法
        this.setSaveData(arr)
        WorkDocModels.push(...arr) // 将结果添加到数组中
        var stage = this.MachiningStageData[index]
        console.log(arr, 'arrss')
        if (arr.length > 0) {
          if (arr[0].batchShowEndTime)
            MachiningStageDates.push({ Stage: stage.MachiningStageId, OrderId: this.data.OrderId, OrderProductId: this.data.OrderProductId, EndTime: arr[0].batchShowEndTime })
        }
      }
      console.log(WorkDocModels, 'save')
      let { OrderProductId, ProductId, DpId, StockQuantity, Quantity, ClothMakeEmpId, ClothRemark, FinishDate, ClothDate, ClothDocDate, BatchNumber } = this.data
      let o = {
        WorkDocModels,
        RubberModels: RubberModelsArr,
        TeProductId: this.TeProductId,
        MaterialModels: MaterialsData,
        OrderProductId,
        ProductId,
        DpId: DpId ?? 0,
        StockQuantity,
        Quantity,
        ClothMakeEmpId,
        ClothRemark,
        FinishDate,
        ClothDate,
        BatchNumber,
        ClothDocDate,
        ClothStages: MachiningStageDates
      }

      console.log('save', o)
      // <!-- h -->
      // var loading = this.$loading({
      //   lock: true,
      //   text: '正在保存...',
      //   spinner: 'el-icon-loading',
      //   customClass: 'my_loading',
      //   background: 'rgba(0, 0, 0, 0.3)'
      // })

      this.workDocApi
        .save(o)
        .then(res => {
          //loading.close() // <!-- h -->
          if (res.Code === 0) {
            console.log('res.Data', res.Data)
            this.$message({ type: 'success', message: '保存成功' })
            // <!-- h -->
            // loading = this.$loading({
            //   lock: true,
            //   text: '正在更新信息...',
            //   spinner: 'el-icon-loading',
            //   customClass: 'my_loading',
            //   background: 'rgba(0, 0, 0, 0.3)'
            // })
            let orderProductId = this.data.OrderProductId
            this.api
              .getInfo(orderProductId)
              .then(res => {
                // loading.close() // <!-- h -->
                if (res.Code === 0) {
                  this.editType = 1
                  // this.editInit(res.Data, this.data)
                }
              })
              .catch(err => {
                // loading.close() // <!-- h -->
              })
          } else {
            this.$message({ type: 'warning', message: res.Msg })
          }
        })
        .catch(err => {
          this.$message({ type: 'warning', message: '请将表格数据填写完整' })
          //loading.close() // <!-- h -->
          console.log(err)
        })
    }

    // chuli_data() {
    //   // 切换标签时，数据联动
    //   if (this.clickAssembling) {
    //     this.clickAssembling = false;
    //     let assembly_data = this.$refs.assembly.get_data();
    //     let tempData1 = assembly_data.filter((item) => {
    //       return item.ProcessStage === 2;
    //     });
    //     this.$refs.parts.setDetailModels(tempData1);

    //     let tempData2 = assembly_data.filter((item) => {
    //       return item.UseProcess && item.PropertyName !== "注塑";
    //     });

    //     this.$refs.special.setDetailModels(tempData2);

    //     let glueData = assembly_data.filter((item) => {
    //       return item.ProcessStage === 1;
    //     });

    //     console.log("====glueData====", JSON.parse(JSON.stringify(glueData)));

    //     // 根据模号分类
    //     let o = {};
    //     glueData.forEach((item) => {
    //       if (o["_" + item.MouldId] == null) {
    //         o["_" + item.MouldId] = [];
    //       }
    //       if (o["_" + item.MouldId]) {
    //         let v = {
    //           ProductId: item.ProductId,
    //           ProductName: item.Pname,
    //           Quantity: Number(item.qua),
    //         };
    //         o["_" + item.MouldId].push(v);
    //       }
    //     });

    //     console.log("*************o=========", JSON.parse(JSON.stringify(o)));

    //     // 根据id 获取产出的胶件及其数量
    //     let mouldId_arr = Object.keys(o);

    //     console.log("mouldId_arr=========", mouldId_arr);

    //     var loading = this.$loading({
    //       lock: true,
    //       text: "正在加载...",
    //       spinner: "el-icon-loading",
    //       customClass: "my_loading",
    //       background: "rgba(0, 0, 0, 0.3)",
    //     });

    //     let Pres = [];
    //     for (let i = 0; i < mouldId_arr.length; ++i) {
    //       let id = Number(mouldId_arr[i].substr(1));
    //       let p = this.mouldApi.info(id);
    //       Pres.push(p);
    //     }

    //     Promise.all(Pres)
    //       .then((res) => {
    //         loading.close();
    //         let length = res.length;
    //         let quas = [];
    //         for (let i = 0; i < length; ++i) {
    //           let dataArr = res[i].Data.Rubbers;
    //           let mouldId = res[i].Data.MouldId;

    //           // 根据对应id拿到之前保存的需求数量
    //           let productsQuas = o["_" + mouldId];
    //           console.log("productsQuas+++++++++++++", productsQuas);

    //           let productsQuaLength = productsQuas.length;
    //           let maxQua = 0;
    //           for (let j = 0; j < productsQuaLength; ++j) {
    //             let mouldQuas = dataArr.filter((item) => {
    //               return item.ProductId === productsQuas[j].ProductId;
    //             })[0];

    //             console.log("mouldQuas+++++++++++++", mouldQuas);

    //             let qua = Math.ceil(
    //               productsQuas[j].Quantity / mouldQuas.Quantity
    //             );

    //             if (qua > maxQua) {
    //               maxQua = qua;
    //             }
    //           }
    //           quas.push({
    //             MouldId: mouldId,
    //             Quantity: maxQua,
    //           });
    //         }
    //         console.log("quas+++++++++++++", JSON.parse(JSON.stringify(quas)));

    //         let mouldIds = glueData.map((item) => {
    //           return item.MouldId;
    //         });

    //         mouldIds = Array.from(new Set(mouldIds)); // 去除重複的id

    //         let ids = this.mouldList.map((item) => {
    //           return item.MouldId;
    //         });

    //         let mouldData = [];

    //         mouldIds.forEach((item) => {
    //           let index = ids.indexOf(item);
    //           let qua = quas.filter((v) => {
    //             return item === v.MouldId;
    //           })[0];
    //           let o = {
    //             Bomno: "",
    //             Quantity: qua.Quantity,
    //             qua: qua.Quantity,
    //             ...this.mouldList[index],
    //           };
    //           mouldData.push(o);
    //         });

    //         console.log(
    //           "mouldData+++++++++++++",
    //           JSON.parse(JSON.stringify(mouldData))
    //         );

    //         let rubbers = [];
    //         let rubbersNumber = [];

    //         res.forEach((item) => {
    //           rubbers.push(...item.Data.Rubbers);
    //         });

    //         rubbersNumber = rubbers.map((item) => {
    //           return {
    //             ProductId: item.ProductId,
    //             Quantity: item.Quantity,
    //           };
    //         });

    //         glueData.forEach((item) => {
    //           let id = item.ProductId;
    //           // let vQuantity = 0;
    //           rubbersNumber.forEach((v) => {
    //             if (id === v.ProductId) {
    //               item.qua = item.qua;
    //               item.Quantity = item.qua;
    //             }
    //           });

    //           console.log("glueData 后", JSON.parse(JSON.stringify(glueData)));
    //         });

    //         this.$refs.injection.setDetailModels(glueData, mouldData);
    //         this.$refs.assembly.clearData();
    //       })
    //       .catch((err) => {
    //         loading.close();
    //       });
    //   }
    // },
  }
}
</script>

<style lang="scss" scoped>
.el-tabs {
  margin: 10px;
}
.el-form-item--mini {
  margin-bottom: 10px;
}
.w193px {
  width: 193px;
}
.w250px {
  width: 250px;
}
.sapn {
  display: inline-block;
  margin-bottom: 10 !important;
}
</style>
